import axios from "axios";

export default {
    sendCpInvite: async (contactId) => {
        const { data } = await axios.post(`/contact/${contactId}/cp_invite`)

        return data
    },
}